import styled from 'styled-components';

import { transition } from 'ggApp/utils/mixins/transition';

const Element = styled.input`
    outline: none;
    appearance: none;
    display: inline-block;
    position: relative;
    width: 24px;
    min-width: 24px;
    max-width: 24px;
    height: 24px;
    min-height: 24px;
    max-height: 24px;
    border: 2px solid;
    border-color: ${({theme}) => theme.colors['Level 2']};
    box-sizing: border-box;
    border-radius: 4px;
    margin: 0px 12px 0px 0px;
    cursor: pointer;

    &:checked {
        background: none;
    }

    &:before {
        content: '';
        display: inline-block;
        position: absolute;
        left: 3px;
        top: 3px;
        width: 14px;
        height: 14px;
        background: ${(props) => props.accentColor || props.theme.colors.secondary};
        border-radius: 1px;
        opacity: ${({ checked }) => (checked ? 1 : 0)};
        ${transition('opacity', 'short', 'out')};
    }
`;

export { Element };
